import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getNotificationOfAssets = (id, useType = 0) => {
  const url = `${API_ROOT}/v1/accounting/project/setting-notification-page?id=${
    id || ''
  }&useType=${useType}`
  return doGet(url)
}

export const saveNotificationOfAssets = (request) => {
  const url = `${API_ROOT}/v1/accounting/project/setting-notification-save`
  return doPost(url, request)
}

export const deleteNotificationOfAssets = (id) => {
  const url = `${API_ROOT}/v1/accounting/project/setting-notification-delete?id=${id || ''}`
  return doDelete(url)
}

export const editNotificationOfAssets = (id, useType = 0) => {
  return getNotificationOfAssets(id, useType)
  // const url = `${API_ROOT}/v1/accounting/project/setting-notification-page?id=${id || ''}`
  // return doGet(url)
}
